module.exports = __webpack_public_path__ + "media/images/20minutes-bg-dbf0005a520c7cf50ce1998dc2da3425.png";